import clsx from 'clsx'
import {
  GenericErrorBoundary,
  LeftSideBar,
  MasterDetail,
  Navigation,
  UserMenuTopBar
} from 'components/core-v2'
import { useMemo, useState } from 'react'

import { AssetsFilterList } from '../assets-filter-list/assets-filter-list'
import { DEFAULT_STATE, OrdersFiltersContext } from '../assets-filter-list/orders-filter-context'
import { OrdersDetail } from '../orders-detail/orders-detail'
import classes from './orders-wrapper.module.scss'

export const OrdersWrapper = () => {
  const [asset, setAsset] = useState(DEFAULT_STATE.asset)
  const contextValue = useMemo(() => ({ asset, setAsset }), [asset])

  return (
    <OrdersFiltersContext.Provider value={contextValue}>
      <GenericErrorBoundary>
        <LeftSideBar
          leftElement={<Navigation />}
          mainElement={
            <main className={clsx(classes.main, classes.backgroundGrey)}>
              <MasterDetail
                detailChildren={<OrdersDetail />}
                masterChildren={<AssetsFilterList />}
              />
            </main>
          }
          topBarElement={<UserMenuTopBar />}
        />
      </GenericErrorBoundary>
    </OrdersFiltersContext.Provider>
  )
}
